import pdfImg from "../../../../assets/images/pdf.png";
import texImg from "../../../../assets/images/tex.png";
import ResumeLinks from "../../../../src/components/ResumeLinks";
import * as React from 'react';
export default {
  pdfImg,
  texImg,
  ResumeLinks,
  React
};